// BULLETPROOF Step 1 Validation - Direct DOM checking, no reliance on events
// This ensures buttons are enabled when all mandatory fields are filled

(function() {
  'use strict';
  
  // Direct function to force enable buttons - removes ALL disabling
  function forceEnableButtons() {
    var form = $('#ad-form-1');
    if (form.length === 0) return;
    
    var buttons = form.find('button.checkMandatory[type="submit"]');
    buttons.each(function() {
      var button = $(this);
      // Remove ALL possible disabling
      button.prop('disabled', false);
      button.removeClass('disabled');
      button.removeClass('disableattchmentbutton');
      // Remove inline styles
      button.css({
        'pointer-events': 'auto',
        'opacity': '1',
        'cursor': 'pointer'
      });
      // Remove disabled attribute
      button.removeAttr('disabled');
    });
  }
  
  // Comprehensive field checking - uses multiple methods for reliability
  function checkAllStep1Fields() {
    var form = $('#ad-form-1');
    if (form.length === 0) return false;
    
    // Check text field (title)
    var textField = form.find('input[name="auction[text]"]');
    var textVal = (textField.val() || '').trim();
    var textOk = textVal !== '' && textVal.length > 0;
    
    // Check body field - try ALL possible methods
    var bodyOk = false;
    
    // Method 1: Trix editor API
    var trixEditor = form.find('trix-editor');
    if (trixEditor.length > 0 && trixEditor[0] && trixEditor[0].editor) {
      try {
        var doc = trixEditor[0].editor.getDocument();
        if (doc && doc.toString) {
          var content = doc.toString();
          var text = $('<div>').html(content).text().trim();
          bodyOk = text !== '' && text.length > 0;
        }
      } catch(e) {
        // Trix API check failed, try other methods
      }
    }
    
    // Method 2: Hidden input (Trix stores content here)
    if (!bodyOk) {
      var bodyHidden = form.find('input[type="hidden"][name="auction[body]"]');
      if (bodyHidden.length > 0) {
        var bodyContent = (bodyHidden.val() || '').trim();
        var bodyText = $('<div>').html(bodyContent).text().trim();
        bodyOk = bodyText !== '' && bodyText.length > 0;
      }
    }
    
    // Method 3: Textarea fallback
    if (!bodyOk) {
      var bodyTextarea = form.find('textarea[name="auction[body]"]');
      if (bodyTextarea.length > 0) {
        var bodyVal = (bodyTextarea.val() || '').trim();
        var bodyText = $('<div>').html(bodyVal).text().trim();
        bodyOk = bodyText !== '' && bodyText.length > 0;
      }
    }
    
    // Check keywords field - MOST IMPORTANT - use DOM directly
    var keywordsOk = false;
    var keywordsField = form.find('select[name="auction[confirm_keywords]"]');
    
    if (keywordsField.length > 0) {
      // Method 1: Check select2 container DOM for visible tags (MOST RELIABLE)
      var select2Container = keywordsField.next('.select2-container');
      if (select2Container.length > 0) {
        var choiceTags = select2Container.find('.select2-selection__choice');
        if (choiceTags.length > 0) {
          keywordsOk = true;
        }
      }
      
      // Method 2: Check val() - array or single value
      if (!keywordsOk) {
        var keywordsVal = keywordsField.val();
        if (Array.isArray(keywordsVal) && keywordsVal.length > 0) {
          keywordsOk = true;
        } else if (keywordsVal && keywordsVal !== '' && keywordsVal !== null && keywordsVal !== undefined) {
          keywordsOk = true;
        }
      }
      
      // Method 3: Check select2 data API
      if (!keywordsOk && keywordsField.data('select2')) {
        try {
          var select2Data = keywordsField.select2('data');
          if (select2Data && select2Data.length > 0) {
            keywordsOk = true;
          }
        } catch(e) {
          // Select2 API check failed, try other methods
        }
      }
      
      // Method 4: Check selected options in DOM
      if (!keywordsOk) {
        var selectedOptions = keywordsField.find('option:selected');
        if (selectedOptions.length > 0) {
          var validOptions = selectedOptions.filter(function() {
            var val = $(this).val();
            return val !== '' && val !== null && val !== undefined;
          });
          if (validOptions.length > 0) {
            keywordsOk = true;
          }
        }
      }
    }
    
    // If ALL fields are filled, enable buttons FORCEFULLY
    if (textOk && bodyOk && keywordsOk) {
      forceEnableButtons();
      return true;
    }
    
    return false;
  }
  
  // Run validation immediately and set up intervals
  function startValidation() {
    // Initial checks
    setTimeout(checkAllStep1Fields, 500);
    setTimeout(checkAllStep1Fields, 1000);
    setTimeout(checkAllStep1Fields, 2000);
    
    // Run VERY frequently to catch any changes
    setInterval(function() {
      if ($('#ad-form-1').length > 0) {
        checkAllStep1Fields();
      }
    }, 250); // Every 250ms - very frequent
  }
  
  // Start when DOM is ready
  $(document).ready(function() {
    startValidation();
    
    // Also start after window load
    $(window).on('load', function() {
      setTimeout(startValidation, 500);
    });
  });
  
  // Listen to ALL possible events for immediate response
  $(document).on('select2:select', 
    '#ad-form-1 select[name="auction[confirm_keywords]"]', 
    function() {
      setTimeout(function() {
        checkAllStep1Fields();
        forceEnableButtons(); // Force enable as backup
      }, 5);
      setTimeout(checkAllStep1Fields, 50);
      setTimeout(checkAllStep1Fields, 150);
      setTimeout(checkAllStep1Fields, 300);
    }
  );
  
  $(document).on('select2:close', 
    '#ad-form-1 select[name="auction[confirm_keywords]"]', 
    function() {
      setTimeout(function() {
        checkAllStep1Fields();
        forceEnableButtons(); // Force enable as backup
      }, 10);
      setTimeout(checkAllStep1Fields, 100);
      setTimeout(checkAllStep1Fields, 250);
      setTimeout(checkAllStep1Fields, 500);
    }
  );
  
  $(document).on('select2:unselect select2:clear', 
    '#ad-form-1 select[name="auction[confirm_keywords]"]', 
    function() {
      setTimeout(checkAllStep1Fields, 100);
    }
  );
  
  $(document).on('change', 
    '#ad-form-1 select[name="auction[confirm_keywords]"]', 
    function() {
      setTimeout(function() {
        checkAllStep1Fields();
        forceEnableButtons();
      }, 50);
    }
  );
  
  $(document).on('input change keyup', 
    '#ad-form-1 input[name="auction[text]"]', 
    function() {
      setTimeout(checkAllStep1Fields, 50);
    }
  );
  
  $(document).on('trix-change trix-initialize', 
    '#ad-form-1 trix-editor', 
    function() {
      setTimeout(checkAllStep1Fields, 50);
    }
  );
  
  // Watch for ANY click in select2 area
  $(document).on('click', 
    '#ad-form-1 .select2-container, #ad-form-1 .select2-selection, #ad-form-1 .select2-dropdown', 
    function() {
      setTimeout(checkAllStep1Fields, 200);
    }
  );
  
  // MutationObserver to watch for DOM changes in select2 container
  $(document).ready(function() {
    setTimeout(function() {
      var keywordsField = $('#ad-form-1 select[name="auction[confirm_keywords]"]');
      if (keywordsField.length > 0) {
        var select2Container = keywordsField.next('.select2-container');
        if (select2Container.length > 0) {
          var observer = new MutationObserver(function(mutations) {
            setTimeout(function() {
              checkAllStep1Fields();
              forceEnableButtons();
            }, 50);
          });
          observer.observe(select2Container[0], {
            childList: true,
            subtree: true,
            attributes: true,
            attributeOldValue: true,
            characterData: true
          });
        }
      }
    }, 1500);
  });
  
  // Expose functions globally for manual triggering
  window.checkStep1Fields = checkAllStep1Fields;
  window.forceEnableStep1Buttons = forceEnableButtons;
})();
